<div class="overlay">
  <img src="/assets/img/datatable/loading.gif" alt="loading"/>
</div>
